module.exports = __webpack_public_path__ + "34800b3f8d2fd8520e3dc3635894726b.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_boxplot.png
// module id = 834
// module chunks = 7